import { defineMessages } from 'react-intl';

/**
 * Copy for the org headings of the grouped site and Bitbucket pickers.
 * Declared once and shared rather than per selector, as with
 * orgMismatchMessages, so one id keeps one string to translate.
 */
export const orgGroupMessages = defineMessages({
  noOrganization: {
    id: 'oauth.mcp.orgGroup.noOrganization',
    defaultMessage: 'No organization',
    description:
      'Heading in the site and Bitbucket workspace pickers, when their options are grouped by Atlassian organization, over the options that belong to no named organization',
  },
});
